import { createSelector } from 'reselect';
import { uniq } from 'lodash';
import { metricSelector, selectedMetricSelector } from '@store/metricsChartContainer/selectors';
import trendsBaseSelector from '@store/trends/base/selectors';
import { summaryWidgetsSelector } from '@store/summaryWidgets/selector';
import { getFirstAppliedFilter, layoutSelector, intervalSelector } from './selectors';

export const dataToPersistSelector: any = createSelector(
  getFirstAppliedFilter,
  summaryWidgetsSelector,
  metricSelector,
  selectedMetricSelector,
  layoutSelector,
  trendsBaseSelector,
  intervalSelector,
  (filter, summaryWidgets, chartMetrics, selectedMetric, layout, trendsBase, interval) => {
    const { granularity = null } = interval;

    const { dimensions: dimensionKeys, globalOrderBy, dimensionMetrics } = trendsBase;
    return {
      filter,
      summaryWidgets,
      chartMetrics,
      selectedMetric,
      layout,
      dimensionKeys,
      globalOrderBy,
      dimensionMetrics,
      granularity,
    };
  },
);

// map/filter persisted metrics to match supported metrics
// accepts array of metrics
// return empty array if there are no valid metrics
export function parseMetricsFn(supportedMetrics) {
  const metricSet = new Set(Object.keys(supportedMetrics));
  return (currentMetrics) => {
    // map name changes if any here

    // filter unsupported metrics
    const filteredMetrics = currentMetrics.filter((m) => metricSet.has(m));
    return uniq(filteredMetrics);
  };
}

export default dataToPersistSelector;
